import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { DesktopNav } from "~/components/admin/navigation/DesktopNav";
import { MobileNav } from "~/components/admin/navigation/MobileNav";
import { Unauthorized } from "~/components/admin/Unauthorized";
import { QueryState } from "~/components/QueryState";
import { SignOut } from "~/components/SignOut";
import { TRPCClientErrorDisplay } from "~/components/TRPCClientErrorDisplay";
import { Spinner } from "~/components/ui/Spinner";
import { useTRPC } from "~/lib/trpc";

export const Route = createFileRoute("/_authenticated/admin")({
  component: AdminRoute,
});

function AdminRoute() {
  const trpc = useTRPC();
  const query = useQuery(trpc.users.current.queryOptions());

  return (
    <div className="min-h-screen bg-[#f3f4f6] text-slate-900">
      <header className="sticky top-0 z-30 border-b border-slate-200/80 bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-[1440px] items-center gap-3 px-4 py-3 sm:px-5 lg:px-8">
          {query.data?.roles.includes("admin") && (
            <div className="md:hidden">
              <MobileNav />
            </div>
          )}

          <div className="flex shrink-0 items-center gap-3">
            <img
              src="/web-app-manifest-512x512.png"
              alt="Goose"
              width={28}
              height={28}
            />
            <div>
              <span className="text-lg font-semibold uppercase tracking-wide text-slate-400">
                Goose
              </span>{" "}
              <span className="font-semibold tracking-tight text-slate-950">
                Admin
              </span>
            </div>
          </div>

          {query.data?.roles.includes("admin") && (
            <div className="hidden min-w-0 flex-1 justify-end md:flex">
              <DesktopNav />
            </div>
          )}

          <div className="ml-auto">
            <SignOut />
          </div>
        </div>
      </header>

      <main>
        <div className="mx-auto max-w-[1440px] px-4 py-4 sm:px-5 lg:px-8 lg:py-6">
          <QueryState
            result={query}
            loading={
              <div className="flex items-center justify-center py-32">
                <Spinner size="lg" className="text-slate-300" />
              </div>
            }
            error={(error) => (
              <div className="py-8">
                <TRPCClientErrorDisplay error={error} />
              </div>
            )}
          >
            {(user) =>
              user.roles.includes("admin") ? <Outlet /> : <Unauthorized />
            }
          </QueryState>
        </div>
      </main>
    </div>
  );
}
